import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu, UserCircle } from 'lucide-react';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const token = localStorage.getItem('admin_token');

  if (!token || token === 'undefined') {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Mobile Header */}
        <header className="lg:hidden bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between sticky top-0 z-30">
          <button 
            onClick={() => setIsSidebarOpen(true)}
            className="p-2 text-slate-600 hover:bg-slate-100 rounded-lg"
          >
            <Menu className="w-6 h-6" />
          </button>
          <span className="font-bold text-slate-900">DudeDex Admin</span>
          <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
            <UserCircle className="w-6 h-6 text-slate-400" />
          </div>
        </header>

        {/* Desktop Top Nav (Optional but nice) */}
        <header className="hidden lg:flex bg-white border-b border-slate-200 px-8 py-4 items-center justify-between">
          <h2 className="text-slate-500 font-medium">Administrator Portal</h2>
          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm font-bold text-slate-900">System Admin</p>
              <p className="text-xs text-slate-500">Super User</p>
            </div>
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center border border-blue-200">
              <UserCircle className="w-6 h-6 text-blue-600" />
            </div>
          </div>
        </header>

        <main className="flex-1 p-4 md:p-8 lg:p-10 min-h-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
